import React, { useContext, useState } from 'react';
import { Script } from 'gatsby';
import { Header, Footer, Consult, SignUpModal, SelfScheduleConsultStub, OnPageSelfScheduleForm } from '../components';
import { GlobalSiteDataContext } from '../context';
import { hardTrim } from '../utils';
import { useSelfScheduleFlags } from '../hooks/useSelfScheduleVariant';
import { useSelfScheduleCtaRedirect } from '../hooks/useSelfScheduleCtaRedirect';
import { useCountdownActive } from '../hooks/useCountdownActive';
import '../utils/styles/global.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

export function Layout({ children, location }) {
    const siteData = useContext(GlobalSiteDataContext);
    const [showSignUpModal, setShowSignUpModal] = useState(false);

    const showCountdown = useCountdownActive();

    // Self-schedule experiment (WEBDEV-4187). Both flags are false unless the
    // page is in SELF_SCHEDULE_PATHS (only /lp today) AND Optimizely has set a
    // variant, so every other page behaves exactly as before. Metros with no
    // open stores are excluded too: they keep the inquiry-only NotOpen form
    // (see Consult.js) whatever the variant. Resolved once here and passed down
    // to Header, so the variant event subscription mounts a single time per page.
    const { active: selfScheduleActive, onPageFormActive } = useSelfScheduleFlags(location.pathname, {
        metroHasOpenStores: siteData.currentMetro.openStores > 0,
    });

    // Redirects #consult CTAs to /schedule while either variant is active.
    useSelfScheduleCtaRedirect(selfScheduleActive);

    return (
        <div
            id={`${location.pathname === '/' ? 'home' : hardTrim(location.pathname)}-page-wrapper`}
            className={showCountdown ? 'with-countdown' : ''}
        >
            <Header siteData={siteData} showCountdown={showCountdown} selfScheduleActive={selfScheduleActive} />
            {children}
            {/* The on-page form renders its own #consult anchor, so this one is
                suppressed on that path — otherwise the id would appear twice. */}
            {!onPageFormActive && <span id="consult"></span>}
            {onPageFormActive ? (
                <OnPageSelfScheduleForm />
            ) : selfScheduleActive ? (
                <SelfScheduleConsultStub />
            ) : (
                <Consult siteData={siteData} />
            )}
            {showSignUpModal && <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />}
            <Footer siteData={siteData} setShowSignUpModal={setShowSignUpModal} />
            <Script key="cloudamp">
                {`
          window._cloudAmp = window._cloudAmp || {};
          _cloudAmp.forms = [];
          (function () {
            var scripts = document.getElementsByTagName('script'),
                sLen = scripts.length,
                ca_script = document.createElement('script'),
                head = document.getElementsByTagName('head'),
                protocol = document.location.protocol,
                httpsDomain = '1d5ef9e9369608f625a8-878b10192d4a956595449977ade9187d.ssl.cf2.rackcdn.com',
                httpDomain = 'trk.cloudamp.net',
                filename = 'ctk.js',
                srcDomain = protocol === 'http:' ? httpDomain : httpsDomain;
  
            ca_script.type = 'text/javascript';
            ca_script.async = true;
            ca_script.src = protocol + '//' + srcDomain + '/' + filename;
            head[0].appendChild(ca_script);
          })();
        `}
            </Script>
        </div>
    );
}

export default Layout;
